<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("paymentAccounts/getDetails", this.itemId);
    },
    computed: {
        paymentAccount() {
            return this.$store.state.paymentAccounts.paymentAccount;
        }
    },
};
</script>